import { render, staticRenderFns } from "./ai-feed.vue?vue&type=template&id=65e0fbd0&scoped=true&"
import script from "./ai-feed.vue?vue&type=script&lang=ts&"
export * from "./ai-feed.vue?vue&type=script&lang=ts&"
import style0 from "./ai-feed.vue?vue&type=style&index=0&id=65e0fbd0&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0fbd0",
  null
  
)

export default component.exports